/*=========================================================================================
  File Name: moduleChatMutations.js
  Description: Chat Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue'

export default {
  UPDATE_ABOUT_CHAT(state, obj) {
    obj.rootState.AppActiveUser.about = obj.value
  },
  UPDATE_STATUS_CHAT(state, obj) {
    obj.rootState.AppActiveUser.status = obj.value
  },

  // API AFTER
  SEND_CHAT_MESSAGE(state, payload) {
    if (payload.chatData) {
      // If there's already chat. Push msg to existing chat
      state.chats[
        Object.keys(state.chats).find((key) => Number(key) === payload.id)
      ].msg.push(payload.msg)
    } else {
      // Create New chat and add msg
      const chatId = payload.id
      Vue.set(state.chats, [chatId], {
        isPinned: payload.isPinned,
        msg: [payload.msg]
      })
    }
  },
  UPDATE_CONTACTS(state, contacts) {
    state.contacts = contacts
  },
  UPDATE_CHAT_CONTACTS(state, chatContacts) {
    state.chatContacts = chatContacts
  },
  UPDATE_CHATS(state, messages) {
    // Store messages as an array in state.chats
    state.chats = messages
  },
  RESET_CHAT_STATE(state) {
    state.chatSearchQuery = ''
    state.contacts = []
    state.chatContacts = []
    state.chats = []
    if (state._unsub) {
      state._unsub.contacts = null
      state._unsub.chat = null
    }
    // Clear current active chat id when resetting state
    state._currentChatId = null
  },
  SET_CONTACTS_UNSUB(state, fn) {
    state._unsub.contacts = fn || null
  },
  SET_CHAT_UNSUB(state, fn) {
    state._unsub.chat = fn || null
    if (!fn) state._currentChatId = null
  },
  // Track the chat id for which the realtime listener is attached
  SET_CURRENT_CHAT_ID(state, id) {
    state._currentChatId = id || null
  },
  SET_CHAT_SEARCH_QUERY(state, query) {
    state.chatSearchQuery = query
  },
  MARK_SEEN_ALL_MESSAGES(state, payload) {
    payload.chatData.msg.forEach((msg) => {
      msg.isSeen = true
    })
  },
  TOGGLE_IS_PINNED(state, payload) {
    state.chats[
      Object.keys(state.chats).find((key) => Number(key) === payload.id)
    ].isPinned = payload.value
  }
}
